import getExistingOrderIDRequest from "../requests/getExistingOrderIDRequest";
import getOrderRequest from "../requests/getOrderRequest";
import getOrderLinesRequest from "../requests/getOrderLinesRequest";
import getOrderChargesRequest from "../requests/getOrderChargesRequest";
import getNewOrderRequest from "../requests/getNewOrderRequest";

const getCartAction = async (session, createNew) => {
    const orderID = await getExistingOrderIDRequest(session);
    if(orderID > 0) {
        const order     = await getOrderRequest(session, orderID);
        const products  = await getOrderLinesRequest(session, orderID);
        const charges   = await getOrderChargesRequest(session, orderID);
        // const prices    = await getOrderPricesRequest(session, orderID);
        return {
            orderID,
            order,
            products,
            charges,
        }
    } else if(createNew) {
        const newOrder = await getNewOrderRequest(session);
        return {
            orderID: newOrder.id,
            order: newOrder,
            items: {},
            prices: {}
        }
    } else {
        return {
            orderID: 0,
            order: null,
            products: null,
            charges: null,
        }
    }
}

export default getCartAction;